module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-hh.7b40a893.png";